import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { InputHandler as t } from "../InputHandler.js";

var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);

  var _super = _createSuper(e);

  function e() {
    var _this;

    _classCallCheck(this, e);

    _this = _super.call(this, !0), _this.registerIncoming("context-menu", function (t) {
      t.data.native.preventDefault();
    });
    return _this;
  }

  return e;
}(t);

export { e as PreventContextMenu, e as default };